import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/table/index.js
// module id = 647
// module chunks = 0